import { fetchAllTariffCatalogProducts } from 'Services/ProductManagement/Features/Product/productSlice'
import { getProductsInTariffParamKey } from 'Services/ProductManagement/Features/Product/utils'
import { useAppDispatch, useTypedSelector } from 'Store'
import { useEffect } from 'react'

function useTariffCatalogProducts(tariffId: string, catalogId: string) {
  const dispatch = useAppDispatch()
  const { allTariffCatalogProducts, allTariffCatalogProductsLoading } = useTypedSelector(
    state => state.product
  )

  const fetchAllTariffCatalogProductsWithoutPagination = () => {
    dispatch(
      fetchAllTariffCatalogProducts({
        [getProductsInTariffParamKey(catalogId)]: tariffId,
        in_catalog: catalogId
      })
    )
  }

  useEffect(() => {
    fetchAllTariffCatalogProductsWithoutPagination()
  }, [])

  return {
    allTariffCatalogProducts,
    allTariffCatalogProductsLoading,
    fetchAllTariffCatalogProductsWithoutPagination
  }
}

export default useTariffCatalogProducts
